import { useSelector } from 'react-redux';

import { selectors } from '../flux/setup-redux.js';

const useRates = () => {
  const rates = useSelector(selectors.rates.fiatRates);
  const loading = useSelector(selectors.rates.loading);
  return { loading, value: rates };
};

export default useRates;
